import Vue from 'vue'
import App from './App.vue'
import VueMeta from 'vue-meta'
import {VueMasonryPlugin} from 'vue-masonry'
import device from 'vue-device-detector'
import router from "./router"

// stylesheets
import './assets/styles/app.scss'

Vue.use(VueMeta);
Vue.use(device);
Vue.use(VueMasonryPlugin)
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router
}).$mount('#app');
